module.exports = {"152527100":"宝昌镇","152527101":"千斤沟镇","152527102":"红旗镇","152527103":"骆驼山镇","152527104":"永丰镇","152527200":"幸福乡","152527201":"贡宝拉格苏木乡","152527500":"万寿滩良种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152527.json
// module id = 444
// module chunks = 0